/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Expected_Updated_At_RequiredInputs */

const en_case_validation_expected_updated_at_required = /** @type {(inputs: Case_Validation_Expected_Updated_At_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh the case before changing contacts.`)
};

const pt_br2_case_validation_expected_updated_at_required = /** @type {(inputs: Case_Validation_Expected_Updated_At_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize o caso antes de alterar os contatos.`)
};

/**
* | output |
* | --- |
* | "Refresh the case before changing contacts." |
*
* @param {Case_Validation_Expected_Updated_At_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_expected_updated_at_required = /** @type {((inputs?: Case_Validation_Expected_Updated_At_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Expected_Updated_At_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_expected_updated_at_required(inputs)
	return pt_br2_case_validation_expected_updated_at_required(inputs)
});